
import { Area } from "../../classes"
import Store from "../../store"
const AreaModule = {
  namespaced: true,
  state: () => ({
    areas: [],
    isLoading: false
  }),
  actions: {
    getAvailableAreas: async ({ commit }, payload) => {
      try {
        let user = Store.getters['user/getUser']
        commit("setAreas", []);
        commit("setIsLoading", true);
        const data = await Area.getAvailableAreas(payload, user ? user : null);
        commit("setAreas", data);
        commit("setIsLoading", false);
        return data;
      } catch (err) {
        commit("setIsLoading", false);
        return err;
      }
    }
  },
  getters: {
    getAreas: state => state.areas,
    getIsLoading: state => state.isLoading,
  },
  mutations: {
    setAreas: (state, areas) => {
      state.areas = areas || [];
    },
    setIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    },
    clearArea: (state) => {
      state.areas = [];
      state.isLoading = false;
    },
  },
};
export default AreaModule;
